import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { productImage, studioApi } from '@/lib/studioApi';
import { productSlug } from '@/lib/studioLinks';
import { useGuidedIds } from '@/lib/guided';
import '@/styles/inspiration.css';

let request = null;
export const useInspiration = () => {
  const [data, setData] = useState(null);
  useEffect(() => { (request ||= studioApi('/inspiration').catch(() => { request = null; return { items: [], categories: [] }; })).then(setData); }, []);
  return data;
};

export const ideaLink = (idea, products) => {
  const product = products?.find(p => p.id === idea.productId);
  return product ? `/gestalten?artikel=${productSlug(product)}&vorlage=${encodeURIComponent(idea.ref)}` : '/gestalten?bereich=textil';
};

const BADGE = { foto: null, vorlage: 'Vorlage', ki: 'KI-Design' };

export const IdeaTile = ({ idea, products, i }) => {
  const ids = useGuidedIds(), tpl = idea.ref.startsWith('tpl:') && idea.ref.slice(4), flow = tpl && ids.includes(tpl) && ideaLink(idea, products).replace(`vorlage=${encodeURIComponent(idea.ref)}`, `gefuehrt=${tpl}`);
  return <div className={`insp-tile ${idea.featured ? 'is-featured' : ''} kind-${idea.kind}`} style={{ animationDelay: `${Math.min(i, 12) * 45}ms` }} data-testid={`inspiration-tile-${idea.id}`}>
    <Link to={ideaLink(idea, products)} className="insp-cover" aria-label={idea.title} data-testid={`inspiration-open-${idea.id}`} />
    <span className="insp-img"><img src={productImage(idea.image)} alt={idea.title} loading="lazy" /></span>
    {BADGE[idea.kind] && <span className="insp-badge">{idea.kind === 'ki' && <Sparkles size={11} />}{BADGE[idea.kind]}</span>}
    <span className="insp-meta"><small>{idea.category}</small><strong>{idea.title}</strong><em>Im Studio öffnen<ArrowRight size={14} /></em>{flow && <Link to={flow} className="insp-guided" data-testid={`inspiration-guided-${idea.id}`}><Sparkles size={13} />Geführt gestalten</Link>}</span>
  </div>;
};

export const withProduct = data => (data?.items || []).map(i => ({ ...i, productId: data.product_id }));

export const InspirationTeaser = ({ products }) => {
  const data = useInspiration(), featured = withProduct(data).filter(i => i.featured).slice(0, 4);
  if (!featured.length) return null;
  return <section className="p-section is-tight" data-testid="inspiration-teaser"><div className="p-wrap">
    <div className="p-row-head"><h2>Ideen für dein Shirt<small>Lass dich inspirieren – und mach daraus dein eigenes Design.</small></h2></div>
    <div className="insp-teaser-grid">{featured.map((idea, i) => <IdeaTile key={idea.id} idea={idea} products={products} i={i} />)}</div>
    <div className="insp-teaser-foot"><Link to="/inspiration" className="insp-teaser-more" data-testid="inspiration-teaser-more">Mehr Ideen ansehen<ArrowRight size={16} /></Link></div>
  </div></section>;
};
